import React, { useEffect, useState } from 'react';
import Fields from '../component/reactive-render/renderFields';
import PageTitle from '../component/typography/PageTitle';
import { useDispatch, useSelector } from 'react-redux';
import { CHECK_FORM, CREATE_FORM_OBJ } from '../form-store/action-types';

const CustomerPage = () => {
  const dispatch = useDispatch();
  const fields = useSelector(({ fields }) => fields);
  const [config, setConfig] = useState(fields[1]);
  
  useEffect(() => {
    setConfig(fields[1]);
  }, [fields]);

  useEffect(() => {
    setTimeout(() => dispatch({ type: CHECK_FORM }), 1);
    dispatch({ type: CREATE_FORM_OBJ, payload: config.name });
  }, [dispatch, config.name]);

  return (
    <>
      <PageTitle>{config.title}</PageTitle>
      <form id='sisp-form' className='sisp-customer-form'>
        {config.fields.map((prps, indx) => (
          <Fields key={prps.name} {...prps} />
        ))}
      </form>
    </>
  );
};

export default CustomerPage;
